import { FirebaseDispatch } from './context'

export function actionSetFirebaseInstance(dispatch: FirebaseDispatch) {
  return (instance: any) => dispatch({ type: 'SET_FIREBASE_INSTANCE', instance })
}

export function actionSetUserId(dispatch: FirebaseDispatch) {
  return (userId: string) => dispatch({ type: 'SET_USER_ID', userId })
}
